import * as actions from 'app/actions/checklist';
import http from 'app/services/http';
import { batch } from 'react-redux';

export const checklistReducer = (
    state = {
        inspectionItems: [],
        inspectionSearchValue: '',
        inspectionSelectedItem: null,
        inspectionSortSelectedItem: {
            name: (config.clientUi === 'voykan' ? config.inspectionColumnsVoykan : config.inspectionColumns)[0].name,
            order: (config.clientUi === 'voykan' ? config.inspectionColumnsVoykan : config.inspectionColumns)[0].order,
        },
        inspectionSelectedFilters: {
            from: '',
            to: '',
            status: [],
            template_id: [],
            employee_id: [],
            transport_id: [],
            transport_group_id: [],
            autocolon_id: [],
        },
        inspectionSelectedFiltersLength: 0,
        inspectionFiltersData: {
            template: [],
            employee: [],
            transport: [],
            transport_group: [],
            autocolon: [],
        },
        templateItems: [],
        templateSearchValue: '',
        templateSelectedItem: null,
        templateSortSelectedItem: {
            name: config.checklistTemplateColumns[0].name,
            order: config.checklistTemplateColumns[0].order,
        },
        templateGroupItems: [],
        groupItems: [],
        groupSelectedItem: null,
        groupSearchValue: '',
    },
    action
) => {
    switch (action.type) {
        case 'CHECKLIST_SET_INSPECTION_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                inspectionItems: items.map((item) => {
                    const createdAtLocal = moment.utc(item.created_at).local().format('YYYY-MM-DD HH:mm:ss');
                    const inspectedAtLocal = item.inspected_at ? moment.utc(item.inspected_at).local().format('YYYY-MM-DD HH:mm:ss') : null;

                    return {
                        ...item,
                        inspected_at: inspectedAtLocal,
                        // «Время проведения» в таблице: осмотр на клиенте, иначе доставка на сервер.
                        created_at: inspectedAtLocal || createdAtLocal,
                        delivered_at: createdAtLocal,
                    };
                }),
            };
        }
        case 'CHECKLIST_SET_INSPECTION_SEARCH_VALUE': {
            const { value } = action.payload;

            return {
                ...state,
                inspectionSearchValue: value,
            };
        }
        case 'CHECKLIST_SET_INSPECTION_SELECTED_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                inspectionSelectedItem: data,
            };
        }
        case 'CHECKLIST_SET_INSPECTION_SORT_SELECTED_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                inspectionSortSelectedItem: {
                    name: data.name,
                    order: state.inspectionSortSelectedItem.name !== data.name ? data.order : state.inspectionSortSelectedItem.order === 'ASC' ? 'DESC' : 'ASC',
                },
            };
        }
        case 'CHECKLIST_SET_INSPECTION_SELECTED_FILTERS': {
            const { data } = action.payload;

            return {
                ...state,
                inspectionSelectedFilters: data,
                inspectionSelectedFiltersLength: Object.values(data).reduce((accumulator, currentValue) => {
                    switch (typeof currentValue) {
                        case 'string':
                            if (currentValue.length) accumulator++;
                            break;
                        case 'object':
                            if (currentValue.length) {
                                accumulator += currentValue.length;
                            }
                            break;
                    }

                    return accumulator;
                }, 0),
            };
        }
        case 'CHECKLIST_RESET_INSPECTION_SELECTED_FILTERS': {
            return {
                ...state,
                inspectionSelectedFilters: {
                    from: '',
                    to: '',
                    status: [],
                    template_id: [],
                    employee_id: [],
                    transport_id: [],
                    transport_group_id: [],
                    autocolon_id: [],
                },
                inspectionSelectedFiltersLength: 0,
            };
        }
        case 'CHECKLIST_SET_INSPECTION_TEMPLATE_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                inspectionFiltersData: {
                    ...state.inspectionFiltersData,
                    template: items,
                },
            };
        }
        case 'CHECKLIST_SET_INSPECTION_EMPLOYEE_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                inspectionFiltersData: {
                    ...state.inspectionFiltersData,
                    employee: items,
                },
            };
        }
        case 'CHECKLIST_SET_INSPECTION_TRANSPORT_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                inspectionFiltersData: {
                    ...state.inspectionFiltersData,
                    transport: items,
                },
            };
        }
        case 'CHECKLIST_SET_INSPECTION_TRANSPORT_GROUP_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                inspectionFiltersData: {
                    ...state.inspectionFiltersData,
                    transport_group: items,
                },
            };
        }
        case 'CHECKLIST_SET_INSPECTION_AUTOCOLON_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                inspectionFiltersData: {
                    ...state.inspectionFiltersData,
                    autocolon: items,
                },
            };
        }
        case 'CHECKLIST_SET_TEMPLATE_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                templateItems: items,
            };
        }
        case 'CHECKLIST_SET_TEMPLATE_SELECTED_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                templateSelectedItem: {
                    ...data,
                    history: [],
                },
            };
        }
        case 'CHECKLIST_SET_TEMPLATE_SEARCH_VALUE': {
            const { value } = action.payload;

            return {
                ...state,
                templateSearchValue: value,
            };
        }
        case 'CHECKLIST_SET_TEMPLATE_SORT_SELECTED_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                templateSortSelectedItem: {
                    name: data.name,
                    order: state.templateSortSelectedItem.name !== data.name ? data.order : state.templateSortSelectedItem.order === 'ASC' ? 'DESC' : 'ASC',
                },
            };
        }
        case 'CHECKLIST_ADD_TEMPLATE_LIST_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                templateItems: [...state.templateItems, data],
            };
        }
        case 'CHECKLIST_UPDATE_TEMPLATE_LIST_ITEM': {
            const { data } = action.payload;
            const res = {
                ...state,
                templateItems: state.templateItems.map((item) => {
                    if (item.id !== data.id) {
                        return item;
                    }
                    return {
                        ...item,
                        ...data,
                    };
                }),
            };
            if (state.templateSelectedItem && data.id === state.templateSelectedItem.id) {
                res.templateSelectedItem = {
                    ...state.templateSelectedItem,
                    ...data,
                };
            }

            return res;
        }
        case 'CHECKLIST_SET_TEMPLATE_GROUP_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                templateGroupItems: items,
            };
        }
        case 'CHECKLIST_SET_TEMPLATE_HISTORY_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                templateSelectedItem: {
                    ...state.templateSelectedItem,
                    history: items,
                },
            };
        }
        case 'CHECKLIST_SET_GROUP_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                groupItems: items,
            };
        }
        case 'CHECKLIST_SET_GROUP_SEARCH_VALUE': {
            const { value } = action.payload;

            return {
                ...state,
                groupSearchValue: value,
            };
        }
        case 'CHECKLIST_ADD_GROUP_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                groupItems: [...state.groupItems, data],
            };
        }
        case 'CHECKLIST_UPDATE_GROUP_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                groupItems: state.groupItems.map((item) => {
                    if (item.id !== data.id) {
                        return item;
                    }

                    return {
                        ...item,
                        ...data,
                    };
                }),
            };
        }
        case 'CHECKLIST_SET_GROUP_SELECTED_ITEM': {
            const { data } = action.payload;

            return {
                ...state,
                groupSelectedItem: {
                    ...data,
                    transports: [],
                },
            };
        }
        case 'CHECKLIST_SET_GROUP_SELECTED_ITEM_DATA': {
            const { items } = action.payload;

            return {
                ...state,
                groupSelectedItem: {
                    ...state.groupSelectedItem,
                    transports: items,
                },
            };
        }
        case 'CHECKLIST_SET_GROUP_SELECTED_ITEM_TRANSPORT': {
            const { id } = action.payload;

            return {
                ...state,
                groupSelectedItem: {
                    ...state.groupSelectedItem,
                    transports: state.groupSelectedItem.transports.map((item) => {
                        if (item.id !== id) {
                            return item;
                        }

                        return {
                            ...item,
                            checked: !item.checked,
                        };
                    }),
                },
            };
        }
        case 'CHECKLIST_SET_GROUP_SELECTED_ITEMS_TRANSPORT': {
            const { bool } = action.payload;

            return {
                ...state,
                groupSelectedItem: {
                    ...state.groupSelectedItem,
                    transports: state.groupSelectedItem.transports.map((item) => {
                        return {
                            ...item,
                            checked: bool,
                        };
                    }),
                },
            };
        }
        case 'CHECKLIST_SET_TEMPLATE_AUTOCOLONS_ITEMS': {
            const { items } = action.payload;

            return {
                ...state,
                templateSelectedItem: {
                    ...state.templateSelectedItem,
                    autocolons: items,
                },
            };
        }
        default:
            return state;
    }
};

export function inspectionLoad() {
    return async function inspectionLoadThunk(dispatch) {
        const { data } = await http.get('/checklist/inspection/list');
        return dispatch(actions.setInspectionItems(data));
    };
}

export function inspectionFilterLoad() {
    return async function inspectionFilterLoadThunk(dispatch) {
        const { data } = await http.get('/checklist/inspection/filter');
        return batch(() => {
            dispatch(actions.setInspectionTemplateItems(data.template));
            dispatch(actions.setInspectionEmployeeItems(data.employee));
            dispatch(actions.setInspectionTransportItems(data.transport));
            dispatch(actions.setInspectionTransportGroupItems(data.transport_group ?? []));
            dispatch(actions.setInspectionAutocolonItems(data.autocolon ?? []));
        });
    };
}

export function templateLoad() {
    return async function templateLoadThunk(dispatch) {
        const { data } = await http.get('/checklist/template');
        return dispatch(actions.setTemplateItems(data));
    };
}

export function templateCreate(params) {
    return async function templateCreateThunk(dispatch) {
        const { data } = await http.post(`/checklist/template`, params);
        return dispatch(actions.addTemplateListItem(data));
    };
}

export function templateUpdate(params) {
    return async function templateUpdateThunk(dispatch) {
        const { data } = await http.put(`/checklist/template/${params.id}`, params);
        return dispatch(actions.updateTemplateListItem(data));
    };
}

export function templateDataLoad(id) {
    return async function templateDataLoadLoadThunk(dispatch) {
        const { data } = await http.get(`/checklist/template/${id}`);
        return dispatch(actions.setTemplateHistoryItems(data.history));
    };
}

export function templateGroupLoad() {
    return async function templateGroupLoadThunk(dispatch) {
        const { data } = await http.get('/checklist/group');
        return dispatch(actions.setTemplateGroupItems(data));
    };
}

export function groupLoad() {
    return async function groupLoadThunk(dispatch) {
        const { data } = await http.get('/checklist/group');
        return dispatch(actions.setGroupItems(data));
    };
}

export function groupCreate(params) {
    return async function groupCreateThunk(dispatch) {
        const { data } = await http.post('/checklist/group', params);
        return dispatch(actions.addGroupListItem(data));
    };
}

export function groupUpdate(id, params) {
    return async function groupCreateThunk(dispatch) {
        const { data } = await http.put(`/checklist/group/${id}`, params);
        return dispatch(actions.updateGroupListItem(data));
    };
}

export function groupDataLoad(id, params) {
    return async function groupDataLoadThunk(dispatch) {
        const { data } = await http.get(`/checklist/group/${id}`, params);
        return dispatch(actions.setGroupSelectedItemData(data));
    };
}

export function groupTransportPush(id, value) {
    return async function groupTransportPushThunk(dispatch) {
        await http.post(`/checklist/group/${id}/transport/${value}`);
        return dispatch(actions.setGroupSelectedItemTransport(value));
    };
}

export function groupTransportDelete(id, value) {
    return async function groupTransportDeleteThunk(dispatch) {
        await http.delete(`/checklist/group/${id}/transport/${value}`);
        return dispatch(actions.setGroupSelectedItemTransport(value));
    };
}

export function groupTransportsPush(id, list) {
    return async function groupTransportPushThunk(dispatch) {
        await http.post(`/checklist/group/${id}/transports`, {
            list,
        });
        return dispatch(actions.setGroupSelectedItemsTransport(true));
    };
}

export function groupTransportsDelete(id) {
    return async function groupTransportDeleteThunk(dispatch) {
        await http.delete(`/checklist/group/${id}/transports`);
        return dispatch(actions.setGroupSelectedItemsTransport(false));
    };
}

export async function downloadPdf(id) {
    return await http.get(`/checklist/inspection/${id}/pdf`, {
        responseType: 'blob',
    });
}

export const downloadDamageReport = async () => {
    try {
        const response = await http.get('/checklist/damage-report', {
            responseType: 'blob',
        });

        const blob = response.data;

        if (!(blob instanceof Blob)) {
            throw new Error('Получены данные не в формате Blob');
        }

        if (blob.size === 0) {
            throw new Error('Получен пустой файл');
        }

        const currentDate = new Date().toISOString().split('T')[0];
        const fileName = `Отчет_по_повреждениям_${currentDate}.xlsx`;

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        return true;
    } catch {
        return false;
    }
};

export function checklistAutocolonPush(id, value) {
    return async function groupTransportPushThunk(dispatch) {
        const { data } = await http.post(`/checklist/template/${id}/autocolon/${value}`);
        return dispatch(actions.updateTemplateListItem(data));
    };
}

export function checklistAutocolonDelete(id, value) {
    return async function groupTransportDeleteThunk(dispatch) {
        const { data } = await http.delete(`/checklist/template/${id}/autocolon/${value}`);
        return dispatch(actions.updateTemplateListItem(data));
    };
}

export function checklistAutocolonsPush(id, list) {
    return async function groupTransportPushThunk(dispatch) {
        const { data } = await http.post(`/checklist/template/${id}/autocolons`, {
            list,
        });
        return dispatch(actions.updateTemplateListItem(data));
    };
}

export function checklistAutocolonsListDelete(id, list) {
    return async function groupTransportPushThunk(dispatch) {
        const { data } = await http.post(`/checklist/template/${id}/autocolons/delete`, {
            list,
        });
        return dispatch(actions.updateTemplateListItem(data));
    };
}

export function checklistAutocolonsDelete(id) {
    return async function groupTransportDeleteThunk(dispatch) {
        const { data } = await http.delete(`/checklist/template/${id}/autocolons`);

        return dispatch(actions.updateTemplateListItem(data));
    };
}

export function templateAutocolonsLoad(id) {
    return async function templateDataLoadLoadThunk(dispatch) {
        const { data } = await http.get(`/checklist/template/${id}/autocolons`);
        return dispatch(actions.setTemplateAutocolonsItems(data.autocolons));
    };
}

export default checklistReducer;
